import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const REGULAR = [
  ["1 bedroom / 1 bathroom", "$100 – $120"],
  ["2 bedrooms / 1 bathroom", "$125 – $150"],
  ["2 bedrooms / 2 bathrooms", "$145 – $175"],
  ["3 bedrooms / 2 bathrooms", "$175 – $220"],
  ["4 bedrooms / 2 bathrooms", "$220 – $275"],
  ["4 bedrooms / 3 bathrooms", "$250 – $325"],
];

const STARTING = [
  { name: "Deep Cleaning", price: "$200" },
  { name: "Move-In / Move-Out", price: "$225" },
  { name: "Office Cleaning", price: "$125" },
  { name: "Apartment Cleaning", price: "$100" },
];

const Pricing = () => (
  <section id="pricing" className="bg-white py-20 sm:py-24" data-testid="pricing-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        align="center"
        eyebrow="Fair & Honest"
        title="Simple & Transparent Pricing"
        subtitle="Estimated ranges and starting prices — no surprises, no hidden fees."
      />

      <div className="mt-14 grid gap-8 lg:grid-cols-5">
        <Reveal className="lg:col-span-3">
          <div className="h-full rounded-2xl border border-[#8E7CC3]/15 bg-[#FAF8FF] p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-10" data-testid="pricing-regular-card">
            <div className="flex items-baseline justify-between gap-4">
              <h3 className="text-2xl font-medium text-[#2C2A35]">Regular Cleaning</h3>
              <span className="text-xs font-semibold uppercase tracking-widest text-[#8E7CC3]">Estimated ranges</span>
            </div>
            <ul className="mt-8 divide-y divide-[#8E7CC3]/10">
              {REGULAR.map(([label, price]) => (
                <li key={label} className="flex items-center justify-between gap-4 py-4">
                  <span className="text-sm font-medium text-[#6B6776] sm:text-base">{label}</span>
                  <span className="whitespace-nowrap text-base font-bold text-[#674EA7] sm:text-lg">{price}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-1 xl:grid-cols-2">
          {STARTING.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.08}>
              <div
                className="flex h-full flex-col justify-between rounded-2xl border border-[#8E7CC3]/15 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
                data-testid={`pricing-card-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <h4 className="text-lg font-medium text-[#2C2A35]">{s.name}</h4>
                <div className="mt-6">
                  <p className="text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Starting at</p>
                  <p className="mt-1 text-3xl font-semibold text-[#8E7CC3]">{s.price}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15}>
        <p className="mx-auto mt-12 max-w-3xl text-center text-sm italic leading-relaxed text-[#6B6776]" data-testid="pricing-disclaimer">
          Final pricing depends on the size, condition, and specific cleaning needs of the property. Contact us for an
          accurate quote.
        </p>
        <div className="mt-8 text-center">
          <a
            href="#quote"
            data-testid="pricing-quote-button"
            className="inline-block rounded-full bg-[#8E7CC3] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white shadow-[0_8px_30px_rgb(142,124,195,0.35)] transition-transform hover:scale-[1.02]"
          >
            Get Your Accurate Quote
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
